var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-header',[_vm._t("title"),_c('div',{staticClass:"space"}),_c('app-offline'),_c('app-connected-user')],2)}
var staticRenderFns = []

export { render, staticRenderFns }